export enum LANGUAGE {
  EN = 'EN',
  FR = 'FR',
  DE = 'DE',
  IT = 'IT',
  ES = 'ES',
  NL = 'NL',
}
